import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { Text } from 'components';
import NeedContext from '../NeedContext';

const Information: React.FC = () => {
  const { need } = React.useContext(NeedContext);
  return (
    <StyledInfoGrid>
      <Text strong>Posted On:</Text>
      <Text>{moment(need.createdAt).format('MMM DD, YYYY')}</Text>
      <Text strong>Agent:</Text>
      <div>
        <Text block>
          {need.rep.firstName} {need.rep.lastName}
        </Text>
        <Text block>
          <a href={`mailto:${need.rep.email}?Subject=${need.subject}`}>
            {need.rep.email}
          </a>
        </Text>
        <Text block>{need.rep.phone}</Text>
      </div>
      <Text strong>Note:</Text>
      <Text>{need.note}</Text>
    </StyledInfoGrid>
  );
};

const StyledInfoGrid = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  grid-row-gap: 10px;
  .need-note {
    grid-column-end: span 2;
  }
`;

export default Information;
